export default __webpack_public_path__ + "images/7ad69d2aee230f7a1dd8284e0beda41b-pride_collections_touchpoint_image_mobile.webp";